module.exports = __webpack_public_path__ + "static/media/Page10.287a57f0.png";